import { jsxs as o, jsx as e } from "react/jsx-runtime";
import { useTranslation as w } from "../../../hooks/useTranslation/index.js";
import { AvatarSize as C } from "../../../components/Avatar/style.js";
import { Icon as c } from "../../../components/Icon/index.js";
import { ProfilePageAction as E, ProfileAction as i } from "../../../types/Profile/index.js";
import { EditAvatarWrapper as R } from "../EditAvatarWrapper/index.js";
import { ProfileHeaderContainer as g, ProfileHeaderHead as B, ProfileAvatarContainer as D, ProfileAvatarContent as P, ProfileAvatarWrapper as x, ProfileAvatar as y, EditAvatarIcon as K, ProfileHeaderContent as U, ProfileHeaderNickname as W, NicknameWrapper as S, NicknameEnhanced as M, ProfileHeaderEditNicknameButton as z, WrapperMember as j, ProfileHeaderMemberTime as G, ProfileHeaderUserLabel as V, IconDefault as t, MyDataButton as q, ProfileHeaderDeals as Y, ProfileDealsButton as J, ProfileHeaderTemperature as Q, ProfileHeaderTotalReactions as X, ProfileHeaderFollow as Z, ProfileHeaderFollowers as $, ProfileHeaderFollowing as ee, FollowActionButtonContainer as k, FollowButton as re, UnfollowButton as oe } from "./style.js";
import { ProfileHeaderSkeleton as He } from "./style.js";
import { ArrowLeft as ae, Camera as le, PenToSquare as ie, CalendarDay as te, FireFlameCurved as ne, User as ce, ChevronRight as de, Tags as pe, TemperatureHigh as he, Heart as fe, CircleUser as me, Check as be } from "@pelando/fontawesome/icons";
const Ae = ({
  actions: l,
  user: a,
  isLogged: d,
  isOwner: n,
  isFollowing: f,
  isAdmin: _,
  isVerified: u,
  hasMyDataButton: m
}) => {
  const { t: r } = w("common"), I = ({
    target: { files: h }
  }) => {
    const s = h == null ? void 0 : h[0];
    s && l({
      type: i.ON_EDIT_AVATAR,
      payload: { file: s }
    });
  }, A = m && n && d, L = !n && !f, N = !n && f, { totalCommentReactions: b, likes: H } = a, p = typeof b == "number", O = p ? r("profile-header-reactions-text") : "Likes", F = p ? b : H, T = r(p ? "profile-header-reactions-icon-label" : "profile-header-reactions-icon-label-like"), v = d && n && !m;
  return /* @__PURE__ */ o(g, { children: [
    /* @__PURE__ */ e(B, { children: /* @__PURE__ */ e(
      c,
      {
        role: "presentation",
        icon: ae,
        "aria-label": r("go-to-back-button-aria-label"),
        onClick: () => l({
          type: E.ON_GO_BACK
        })
      }
    ) }),
    /* @__PURE__ */ e(D, { children: d && n ? /* @__PURE__ */ e(P, { children: /* @__PURE__ */ e(R, { onFileChange: I, children: /* @__PURE__ */ o(x, { children: [
      /* @__PURE__ */ e(
        y,
        {
          src: a.avatar,
          size: C.PROFILE,
          alt: r("profile-header-avatar-text")
        }
      ),
      /* @__PURE__ */ e(K, { role: "presentation", icon: le })
    ] }) }) }) : /* @__PURE__ */ e(P, { children: /* @__PURE__ */ e(
      y,
      {
        src: a.avatar,
        alt: r("profile-header-avatar-text"),
        size: C.PROFILE
      }
    ) }) }),
    /* @__PURE__ */ o(U, { children: [
      /* @__PURE__ */ o(W, { children: [
        /* @__PURE__ */ e(S, { children: /* @__PURE__ */ e(M, { isVerified: u, children: a.nickname }) }),
        v && /* @__PURE__ */ e(
          z,
          {
            type: "button",
            onClick: () => l({
              type: i.ON_EDIT_NICKNAME
            }),
            children: /* @__PURE__ */ e(
              c,
              {
                role: "presentation",
                icon: ie,
                "aria-label": r("profile-header-edit-nickname-aria-label")
              }
            )
          }
        )
      ] }),
      /* @__PURE__ */ o(j, { children: [
        /* @__PURE__ */ o(G, { children: [
          /* @__PURE__ */ e(
            c,
            {
              role: "presentation",
              icon: te,
              "aria-label": r("profile-header-icon-calendary-aria-label")
            }
          ),
          /* @__PURE__ */ o("span", { children: [
            r("profile-header-member-since"),
            " ",
            a.memberSince
          ] })
        ] }),
        _ && /* @__PURE__ */ o(V, { children: [
          /* @__PURE__ */ e(
            t,
            {
              role: "presentation",
              icon: ne,
              "aria-label": r("profile-header-icon-fire-flame-aria-label")
            }
          ),
          r("profile-header-member-internal")
        ] })
      ] }),
      A && /* @__PURE__ */ o(
        q,
        {
          onClick: () => l({
            type: i.ON_CLICK_MY_DATA,
            payload: void 0
          }),
          children: [
            /* @__PURE__ */ e(
              t,
              {
                role: "presentation",
                icon: ce,
                "aria-label": r("profile-header-icon-tags-aria-label")
              }
            ),
            r("profile-header-my-data-button"),
            /* @__PURE__ */ e(c, { icon: de })
          ]
        }
      ),
      /* @__PURE__ */ o(Y, { children: [
        /* @__PURE__ */ e(
          t,
          {
            role: "presentation",
            icon: pe,
            "aria-label": r("profile-header-icon-tags-aria-label")
          }
        ),
        /* @__PURE__ */ o(
          J,
          {
            onClick: () => l({
              type: i.ON_CLICK_DEALS,
              payload: void 0
            }),
            type: "button",
            children: [
              /* @__PURE__ */ e("b", { children: a.totalDeals }),
              r("profile-header-total-promotions")
            ]
          }
        )
      ] }),
      /* @__PURE__ */ o(Q, { children: [
        /* @__PURE__ */ e(
          t,
          {
            role: "presentation",
            icon: he,
            "aria-label": r("profile-header-icon-temperature-fire-aria-label")
          }
        ),
        /* @__PURE__ */ o("p", { children: [
          /* @__PURE__ */ o("b", { children: [
            a.maxTemperature,
            "º"
          ] }),
          r("profile-header-total-high-promotion")
        ] })
      ] }),
      /* @__PURE__ */ o(X, { children: [
        /* @__PURE__ */ e(
          t,
          {
            role: "presentation",
            icon: fe,
            "aria-label": T
          }
        ),
        /* @__PURE__ */ o("p", { children: [
          /* @__PURE__ */ e("b", { children: F }),
          " ",
          O
        ] })
      ] }),
      /* @__PURE__ */ o(Z, { children: [
        /* @__PURE__ */ e(t, { role: "presentation", icon: me }),
        /* @__PURE__ */ e(
          $,
          {
            onClick: () => l({
              type: i.ON_CLICK_FOLLOWERS,
              payload: { userId: a.id }
            }),
            type: "button",
            children: /* @__PURE__ */ o("p", { children: [
              /* @__PURE__ */ e("b", { children: a.totalFollowedUsers }),
              r("profile-header-total-followed")
            ] })
          }
        ),
        /* @__PURE__ */ e(
          ee,
          {
            onClick: () => l({
              type: i.ON_CLICK_FOLLOWING,
              payload: { userId: a.id }
            }),
            type: "button",
            children: /* @__PURE__ */ o("p", { children: [
              /* @__PURE__ */ e("b", { children: a.totalUsersFollowing }),
              r("profile-header-total-following")
            ] })
          }
        )
      ] })
    ] }),
    L && /* @__PURE__ */ e(k, { children: /* @__PURE__ */ e(
      re,
      {
        onClick: () => l({
          type: i.ON_CLICK_TO_FOLLOW,
          payload: { userId: a.id }
        }),
        children: r("profile-header-follow-button")
      }
    ) }),
    N && /* @__PURE__ */ e(k, { children: /* @__PURE__ */ o(
      oe,
      {
        onClick: () => l({
          type: i.ON_CLICK_TO_UNFOLLOW,
          payload: { userId: a.id }
        }),
        children: [
          /* @__PURE__ */ e(c, { role: "presentation", icon: be }),
          " ",
          r("profile-header-total-following")
        ]
      }
    ) })
  ] });
};
export {
  y as ProfileAvatar,
  Ae as ProfileHeader,
  He as ProfileHeaderSkeleton
};
